<template>
  <ModalConfirmation
    hasBlur
    :showModal="true"
    title="Revoke access"
  >
    <template v-slot:body>
      <ParagraphBody>
        {{ title }}
      </ParagraphBody>
      <ParagraphBody>
        Are you sure you want to revoke access?
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroup
        :isFullWidth="false"
      >
        <Button
          hasNoBackground
          :isDisabled="isLoading"
          text="cancel"
          @click="handleCancel"
        />
        <Button
          hasOutline
          :isDisabled="isLoading"
          :isLoading="isLoading"
          text="confirm revoke"
          type="error"
          @click="handleConfirm"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>

import {
  Button,
  ButtonGroup,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';

export default {

  name: 'SharedFolderRevokeConfirmationModal',

  components: {
    Button,
    ButtonGroup,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    title: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    handleCancel() {
      this.$emit('close');
    },

    async handleConfirm() {
      this.$emit('revokeAccess');
    },
  },
};
</script>
